import { slugs } from '@/constants/slugs'

export type ManualUpcomingCollectionContent = {
  guid: string
  slug: string
  projectSlug: string
  name: string
  subtitle?: string | null
  description?: string | null
  posterLandscapeCloudinaryPath?: string | null
  duration?: number | null
  episodeNumber?: number | null
  publiclyAvailableDate?: string | null
  earlyAccessDate?: string | null
  guildAvailableDate?: string | null
  releaseDate?: string | null
  type: 'EPISODE' | 'MOVIE'
}

export const WATCH_COLLECTION_UPCOMING_CONTENT: Record<string, ManualUpcomingCollectionContent[]> = {
  [slugs.homesteadSeries]: [
    {
      guid: 'bff21208-5a2e-46f9-8c42-8f99228a6d97',
      slug: 'homestead-s01-e07',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 7',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 7,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-25T00:00:00Z',
      guildAvailableDate: '2025-12-25T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: '94be1832-615b-494e-8248-b40916477dfa',
      slug: 'homestead-s01-e08',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 8',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 8,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-26T00:00:00Z',
      guildAvailableDate: '2025-12-26T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
  ],
}
